import { getApiBaseUrl } from './ApiClient';

export function foodImageSource(image, mimeType = 'image/jpeg') {
  if (typeof image === 'string' && image) {
    if (/^(https?:|data:|blob:)/i.test(image)) return image;
    return new URL(image.replace(/^\/?uploads\//, '/uploads/'), `${new URL(getApiBaseUrl()).origin}/`).href;
  }
  if (Array.isArray(image?.data) && image.data.length) {
    let binary = '';
    for (const byte of image.data) binary += String.fromCharCode(byte);
    return `data:${mimeType || 'image/jpeg'};base64,${btoa(binary)}`;
  }
  return '';
}
